import i18n from 'i18n';
import { LanguageType } from 'scheme/languageType';
import styled from 'styled-components';
import { theme } from 'styles/theme';
import { parseLanguageType } from 'utils/parseLanguageType';

export default function SubTitle() {
  console.log(i18n.language);
  return (
    <ContentTextContainer>
      {parseLanguageType(i18n.language) === LanguageType.KO ? (
        <>
          <TextContainer>
            <Text>커플템 다 맞췄다고 생각하셨나요? 아직 남았어요.</Text>
          </TextContainer>
          <TextContainer>
            <EmphasizedText>커플테마 선물</EmphasizedText>
            <Text>하고,</Text>
            <EmphasizedText> 우리만 아는 꽁냥템 </EmphasizedText>
            <Text>사용해보세요!</Text>
          </TextContainer>
        </>
      ) : (
        <>
          <TextContainer>
            <Text>Did you think you matched all the couple items?</Text>
          </TextContainer>
          <TextContainer>
            <Text> There’s still more. Present matching couple themes to your love!</Text>
          </TextContainer>
        </>
      )}
    </ContentTextContainer>
  );
}

const ContentTextContainer = styled.div`
  text-align: center;
  font-size: 1.35rem;
  line-height: 1.8rem;
  margin-top: 1rem;
`;

const EmphasizedText = styled.div`
  @media screen and ${theme.device.mobile} {
    font-weight: 900;
  }
  @media screen and ${theme.device.mobileMini} {
    font-weight: 900;
  }

  font-weight: 800;
  z-index: 100;
  white-space: pre-wrap;
`;

const Text = styled.div`
  z-index: 200;
  display: flex;
  justify-content: center;
`;

const TextContainer = styled.div`
  display: flex;
  justify-content: center;
  z-index: 100;
`;
